<p-toast position='top-center'></p-toast>
<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form-container">
    <div class='home'>
        <div class="info">You have rights on these countries : {{ authorized_countries && authorized_countries.length ? authorized_countries : 'None' }} </div>
    </div>
    <h4>Add constraint</h4>
    <div class="form-group">
        <label for="itemConstraintType"
                class="label-with-icon"
                [escape]="false"
                pTooltip="FORBIDDEN_DISCOUNT_PRICE: Prevent stores & SAP to apply discount on models <br> FORBIDDEN_STORE_PRICE: Prevent store to make local price on models <br> SEASON_SALES_EXCLUDED: Exclude models from sales & retention period"
                tooltipPosition="top">
        <i class="pi pi-info-circle"></i>
        <span>Constraint type</span>
        </label>
        <select id="itemConstraintType" formControlName="constraintType">
            <option *ngFor="let type of itemConstraintType" [value]="type">
                {{ type }}
            </option>
        </select>
    </div>

    <div class="form-group">
        <label for="options">Models (Enter models split by comma)</label>
        <textarea id="options" formControlName="modelsList" placeholder="Enter models split by comma"></textarea>
    </div>

    <div class="form-group">
        <label for="tierCode"
                class="label-with-icon"
                [escape]="false"
                pTooltip="15 for country, 7 for store, then country or store number: example: 15_5_5 for Belgium or 7_118_118 for store campus"
                tooltipPosition="top">
        <i class="pi pi-info-circle"></i>
        <span>Tier Code</span>
        </label>
        <input id="tierCode" formControlName="tierCode" type="text" placeholder="Format : 15_5_5" />
    </div>

    <div class="form-group">
        <label for="comment">What's the imperative behind blocking these prices?</label>
        <textarea id="comment" formControlName="comment" placeholder="Add a comment (optional)"></textarea>
    </div>

    <div class="form-group">
        <label for="startDate">Start date</label>
        <input id="startDate" formControlName="startDate" type="date" />
    </div>

    <div class="form-group">
        <label for="endDate"
                class="label-with-icon"
                [escape]="false"
                pTooltip="The selected end date starts at 00:00, so it is excluded."
                tooltipPosition="top">
        <i class="pi pi-info-circle"></i>
        <span>End date</span>
        </label>
        <input id="endDate" formControlName="endDate" type="date" />
    </div>

    <div class="form-group">
        <button type="submit" [disabled]="!form.valid || isSending">Send</button>
    </div>
</form>
